module.exports = __webpack_public_path__ + "static/media/ydeo_connect.a64a30f3.png";